import React from 'react'

import { ClientFiltersSection, ClientFiltersSectionProps } from './ClientFiltersSection'
import { CheckboxGroup } from '../../../atoms/formElements/CheckboxGroup'

type Item<T> = {
  id: T
  text: string | React.ReactNode
}

export type ClientFiltersCheckboxSectionProps<T> = ClientFiltersSectionProps & {
  items: Item<T>[]
  name: string
  values: T[]
  onChange: (values: T[]) => void
}

export const ClientFiltersCheckboxSection = <T extends string>({
  items,
  name,
  values,
  onChange,
  ...props
}: ClientFiltersCheckboxSectionProps<T>) => {
  return (
    <ClientFiltersSection {...props}>
      <CheckboxGroup
        options={items}
        value={values}
        onChange={(newValues) => onChange(newValues as T[])}
        name={name}
        baseInputStyle={{ marginBottom: 0 }}
        checkboxStyle={{ marginRight: 16 }}
        checkboxInputStyle={{ marginBottom: 8 }}
      />
    </ClientFiltersSection>
  )
}
